import {RuleInputType, RuleTabEnum} from "./enum/RuleTab.enum";
import i18n from 'i18next';

export function TableColumns(key: RuleTabEnum): string[] {
    switch (key) {
        case RuleTabEnum.CriteriaType:
            return ["ID", i18n.t('ruleManagement.fields.criteriaType.name.name'), i18n.t('ruleManagement.fields.criteriaType.key.name'),i18n.t('ruleManagement.fields.criteriaType.hasPredefinedValue.tableName'), "Tenant"];
        case RuleTabEnum.RuleTemplate:
            return ["ID", i18n.t('ruleManagement.fields.ruleTemplate.name.name'),i18n.t('ruleManagement.fields.ruleTemplate.child.tableName'), "Tenant"];
        case RuleTabEnum.Rule:
            return ["ID", i18n.t('ruleManagement.fields.rule.ruleKey.name'),i18n.t('ruleManagement.fields.rule.effectiveDate.name'),i18n.t('ruleManagement.fields.rule.endDate.name'),i18n.t('ruleManagement.fields.rule.criteria.name'),"İşlemler"];
        default:
            return [];
    }
}

export function Tabs(key: RuleTabEnum) {
    switch (key) {
        case RuleTabEnum.CriteriaType:
            return {id: RuleTabEnum.CriteriaType, name: i18n.t('ruleManagement.criteriaType')}
        case RuleTabEnum.RuleTemplate:
            return {id: RuleTabEnum.RuleTemplate, name: i18n.t('ruleManagement.ruleTemplate')}
        case RuleTabEnum.Rule:
            return {id: RuleTabEnum.Rule, name: i18n.t('ruleManagement.rule')}
        default:
            return {};
    }
}

export const TabsDict = () => {
    return [
        {id: RuleTabEnum.CriteriaType, name: i18n.t('ruleManagement.criteriaType'),},
        {id: RuleTabEnum.RuleTemplate, name: i18n.t('ruleManagement.ruleTemplate')},
        {id: RuleTabEnum.Rule, name: i18n.t('ruleManagement.rule')},
    ];
}
export const ModalContent = [
    {
        id: RuleTabEnum.CriteriaType,
        default: true,
        content: {
            title: "Kriter Tipi Oluşturma"
        },
        fields: [
            {
                name: "Key",
                key: "key",
                required: true,
                visible: true,
                value: "",
                inputType: RuleInputType.Text
            },
            {
                name: "Id",
                key: "id",
                required: true,
                visible: false,
                disabled: true,
                value: "",
                inputType: RuleInputType.Text
            },
            {
                name: "Name",
                key: "name",
                required: true,
                visible: true,
                value: "",
                inputType: RuleInputType.Text
            },
            {
                name: "Tenant",
                key: "tenant",
                required: true,
                visible: true,
                disabled: true,
                value: 3,
                inputType: RuleInputType.TenantInput
            },
            {
                name: "Has Predefined Value?",
                key: "hasPredefinedValue",
                required: true,
                visible: true,
                value: false,
                inputType: RuleInputType.Checkbox,
                childItemKey: "criteriaTypeValues"
            },
            {
                name: "Criteria Type Values",
                key: "criteriaTypeValues",
                required: true,
                visible: false,
                value: "",
                hasChildItem: true,
                inputType: RuleInputType.MultipleInput,
                child: []
            },

        ]
    },
    {
        id: RuleTabEnum.RuleTemplate,
        content: {
            title: "Kural Şablonu Oluşturma"
        },
        fields: [
            {
                name: "Id",
                key: "id",
                required: true,
                visible: false,
                disabled: true,
                value: "",
                hasChildItem: false,
                inputType: RuleInputType.Text
            },
            {
                name: "Name",
                key: "name",
                required: true,
                visible: true,
                value: "",
                inputType: RuleInputType.Text
            },
            {
                name: "Tenant",
                key: "tenant",
                required: true,
                visible: true,
                disabled: true,
                value: 3,
                inputType: RuleInputType.TenantInput,
                child: [],
            },
            {
                name: "Criteria Type",
                key: "criteriaTypes",
                required: true,
                hasChildItem: true,
                visible: true,
                value: "",
                child: [],
                inputType: RuleInputType.CriteriaTypeInput
            },
        ]
    },
    {
        id: RuleTabEnum.Rule,
        content: {
            title: "Kural Oluşturma"
        },
        fields: [
            {
                name: "Id",
                key: "id",
                required: true,
                visible: false,
                disabled: true,
                value: "",
                hasChildItem: false,
                inputType: RuleInputType.Text
            },
            {
                name: "Rule Template",
                key: "ruleTemplateId",
                required: true,
                hasChildItem: true,
                visible: true,
                value: "",
                child: [],
                childItemKey: "ruleTemplateId,tenant,regionId,action,ruleKey,ruleTemplateId,criteria",
                inputType: RuleInputType.RuleTemplateInput
            },
            {
                name: "RuleKey",
                key: "ruleKey",
                required: true,
                visible: false,
                value: "",
                inputType: RuleInputType.Text
            },
            {
                name: "Action",
                key: "action",
                required: true,
                visible: false,
                value: "",
                inputType: RuleInputType.Text
            },
            {
                name: "Region",
                key: "regionId",
                required: true,
                visible: false,
                disabled: true,
                value: "1",
                inputType: RuleInputType.RegionInput
            },
            {
                name: "Tenant",
                key: "tenant",
                inputType: RuleInputType.TenantInput,
                required: true,
                disabled: true,
                visible: false,
                value: 3,
                child: [],
            },
            {
                name: "Criteria",
                key: "criteria",
                inputType: RuleInputType.RuleCriteriaTypeInput,
                required: true,
                disabled: true,
                visible: false,
                hasChildItem: true,
                value: 3,
                child: [],
            }

        ]
    },
];

export const RuleTenant = {
    0: 'Global',
    1: 'Customer',
    2: 'Payment',
    3: 'Fulfillment',
    4: 'Delivery',
    5: 'Product',
    6: 'Stock',
    7: 'Marketplace',
    8: 'Backoffice',
    9: 'YdCheckout',
    10: 'YdPostCheckout',
    11: 'YdMarketplace',
    12: 'Catalog',
    13: 'Checkout',
    14: 'Cms',
    15: 'CustomerEngagement',
    16: 'Mobile',
    17: 'Return',
    18: 'Web',
};

export const Operators = () => {
    return [
        {label: i18n.t(`ruleManagement.operators.equalTo`), value: 0},
        {label: i18n.t(`ruleManagement.operators.openInterval`), value: 1},
        {label: i18n.t(`ruleManagement.operators.closedInterval`), value: 2},
        {label: i18n.t(`ruleManagement.operators.leftClosedInterval`), value: 3},
        {label: i18n.t(`ruleManagement.operators.rightClosedInterval`), value: 4},
        {label: i18n.t(`ruleManagement.operators.contains`), value: 5}]
};

